import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

const articleGroups = [
  {
    label: 'Sicurezza',
    items: [
      { slug: 'sicurezza-acquisti', title: 'Guida alla Sicurezza' },
      { slug: 'qc-photo-guida', title: 'QC Photos' },
      { slug: 'pagamenti-sicuri', title: 'Pagamenti Sicuri' },
    ],
  },
  {
    label: 'Confronti',
    items: [
      { slug: 'confronto-agent', title: 'Shopping Agent' },
      { slug: 'analisi-prezzi', title: 'Analisi Prezzi' },
      { slug: 'alternative-itaobuy', title: 'Alternative' },
    ],
  },
  {
    label: 'Avanzati',
    items: [
      { slug: 'strategie-itaobuy', title: 'Strategie' },
      { slug: 'risparmio-itaobuy', title: 'Risparmio' },
      { slug: 'ottimizzazione-ordini', title: 'Ottimizzazione' },
    ],
  },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [catDropdownOpen, setCatDropdownOpen] = useState(false);
  const [articleDropdownOpen, setArticleDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = () => {
      setCatDropdownOpen(false);
      setArticleDropdownOpen(false);
    };
    if (catDropdownOpen || articleDropdownOpen) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [catDropdownOpen, articleDropdownOpen]);

  const defaultTextColor = scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white';
  const mobileLinkClass = 'flex items-center gap-3 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer transition-colors';
  const mobileSectionClass = 'text-foreground-400 text-xs font-semibold uppercase tracking-wider pt-3 pb-1';

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md'
            : 'bg-transparent'
        }`}
        style={scrolled ? { boxShadow: '0 2px 20px rgba(0,0,0,0.06)' } : {}}
      >
        <div className="px-4 md:px-6 max-w-full mx-auto">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-1 md:gap-6">
              <Link
                to="/"
                className={`text-base md:text-lg font-heading font-semibold tracking-wide whitespace-nowrap cursor-pointer px-2 py-1 rounded-md transition-colors ${
                  scrolled ? 'text-foreground-900 hover:bg-background-100' : 'text-white hover:bg-white/10'
                }`}
              >
                <i className="ri-home-4-line mr-1.5"></i>
                <span className="hidden md:inline">itaobuy spread.pics</span>
                <span className="md:hidden">itaobuy</span>
              </Link>
              <div className="hidden md:flex items-center gap-5 text-sm">
                <Link
                  to="/"
                  className={`whitespace-nowrap cursor-pointer transition-colors font-medium ${defaultTextColor}`}
                >
                  Home
                </Link>

                <div className="relative">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setCatDropdownOpen(!catDropdownOpen);
                      setArticleDropdownOpen(false);
                    }}
                    className={`flex items-center gap-1 whitespace-nowrap cursor-pointer transition-colors ${defaultTextColor}`}
                  >
                    Categorie
                    <i className={`ri-arrow-down-s-line text-sm transition-transform ${catDropdownOpen ? 'rotate-180' : ''}`}></i>
                  </button>
                  {catDropdownOpen && (
                    <div
                      className="absolute top-full left-0 mt-2 w-64 bg-background-50 rounded-xl py-2 max-h-[420px] overflow-y-auto z-50"
                      style={{ boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}
                    >
                      {categories.map((cat) => (
                        <a
                          key={cat.id}
                          href={cat.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 cursor-pointer transition-colors"
                        >
                          <span className="w-7 h-7 rounded-full bg-background-100 flex items-center justify-center">
                            <i className={`${cat.icon} text-sm`}></i>
                          </span>
                          <span>{cat.nameIt}</span>
                          <span className="text-foreground-400 text-xs ml-auto">{cat.nameEn}</span>
                        </a>
                      ))}
                    </div>
                  )}
                </div>

                <div className="relative">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setArticleDropdownOpen(!articleDropdownOpen);
                      setCatDropdownOpen(false);
                    }}
                    className={`flex items-center gap-1 whitespace-nowrap cursor-pointer transition-colors ${defaultTextColor}`}
                  >
                    Guida all&apos;Acquisto
                    <i className={`ri-arrow-down-s-line text-sm transition-transform ${articleDropdownOpen ? 'rotate-180' : ''}`}></i>
                  </button>
                  {articleDropdownOpen && (
                    <div
                      className="absolute top-full left-0 mt-2 w-72 bg-background-50 rounded-xl py-3 px-1 max-h-[520px] overflow-y-auto z-50"
                      style={{ boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}
                    >
                      <Link
                        to="/articoli/guida-completa-itaobuy-spreadsheet"
                        className="block px-4 py-2.5 mb-2 mx-2 text-sm font-semibold text-primary-600 bg-primary-50 rounded-lg hover:bg-primary-100 cursor-pointer transition-colors"
                      >
                        <i className="ri-book-open-line mr-2"></i>
                        Guida Completa
                      </Link>
                      {articleGroups.map((group) => (
                        <div key={group.label} className="mb-1">
                          <p className="px-4 py-1.5 text-xs font-semibold text-foreground-400 uppercase tracking-wider">
                            {group.label}
                          </p>
                          {group.items.map((item) => (
                            <Link
                              key={item.slug}
                              to={`/articoli/${item.slug}`}
                              className="flex items-center gap-2.5 px-4 py-2 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 cursor-pointer transition-colors"
                            >
                              <i className="ri-article-line text-foreground-400"></i>
                              {item.title}
                            </Link>
                          ))}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <Link
                  to="/author"
                  className={`whitespace-nowrap cursor-pointer transition-colors ${defaultTextColor}`}
                >
                  Chi Siamo
                </Link>
              </div>
            </div>

            <div className="hidden md:flex items-center gap-3">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                itaobuy sheet
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 text-sm font-medium rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                buy it now
              </a>
            </div>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer rounded-lg transition-colors ${
                scrolled ? 'text-foreground-900 hover:bg-background-100' : 'text-white hover:bg-white/10'
              }`}
            >
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            </button>
          </div>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden fixed inset-0 top-16 z-40 bg-background-50 px-5 py-5 overflow-y-auto">
          <div className="flex flex-col">

            <Link to="/" onClick={() => setMobileOpen(false)} className={`${mobileLinkClass} font-semibold text-foreground-900`}>
              <i className="ri-home-4-line text-base w-5 flex-shrink-0"></i>
              <span>Home</span>
            </Link>

            <div className="border-t border-background-200 mt-2 pt-3">
              <p className={mobileSectionClass}>
                <i className="ri-price-tag-3-line mr-1.5"></i>
                Categorie Prodotti
              </p>
              <div className="grid grid-cols-2 gap-x-3 gap-y-0.5 mt-1">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-2 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer transition-colors"
                  >
                    <span className="w-6 h-6 rounded-full bg-background-100 flex items-center justify-center flex-shrink-0">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    <span className="truncate">{cat.nameIt}</span>
                  </a>
                ))}
              </div>
            </div>

            <div className="border-t border-background-200 mt-2 pt-3">
              <p className={mobileSectionClass}>
                <i className="ri-shopping-bag-3-line mr-1.5"></i>
                Guida all&apos;Acquisto
              </p>
              <Link to="/articoli/guida-completa-itaobuy-spreadsheet" onClick={() => setMobileOpen(false)} className={`${mobileLinkClass} font-semibold text-primary-600`}>
                <i className="ri-book-open-line text-base w-5 flex-shrink-0"></i>
                <span>Guida Completa</span>
              </Link>
              {articleGroups.map((group) => (
                <div key={group.label} className="ml-5 mt-1">
                  <p className="text-xs text-foreground-400 font-medium uppercase tracking-wide mb-1">{group.label}</p>
                  {group.items.map((item) => (
                    <Link
                      key={item.slug}
                      to={`/articoli/${item.slug}`}
                      onClick={() => setMobileOpen(false)}
                      className="flex items-center gap-2 py-2 text-sm text-foreground-600 hover:text-foreground-950 cursor-pointer transition-colors"
                    >
                      <i className="ri-article-line text-xs w-4 flex-shrink-0"></i>
                      <span>{item.title}</span>
                    </Link>
                  ))}
                </div>
              ))}
            </div>

            <div className="border-t border-background-200 mt-3 pt-3">
              <Link to="/author" onClick={() => setMobileOpen(false)} className={mobileLinkClass}>
                <i className="ri-user-star-line text-base w-5 flex-shrink-0"></i>
                <span>Chi Siamo</span>
              </Link>
              <Link to="/about-itaobuy-spreadsheet" onClick={() => setMobileOpen(false)} className={mobileLinkClass}>
                <i className="ri-information-line text-base w-5 flex-shrink-0"></i>
                <span>Authority</span>
              </Link>
              <Link to="/privacy-policy" onClick={() => setMobileOpen(false)} className={mobileLinkClass}>
                <i className="ri-shield-check-line text-base w-5 flex-shrink-0"></i>
                <span>Privacy Policy</span>
              </Link>
              <Link to="/disclaimer" onClick={() => setMobileOpen(false)} className={mobileLinkClass}>
                <i className="ri-file-text-line text-base w-5 flex-shrink-0"></i>
                <span>Disclaimer</span>
              </Link>
            </div>

            <div className="flex flex-col gap-2.5 mt-5 pb-8">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-full py-3.5 text-center text-sm font-semibold rounded-full bg-primary-500 text-background-50 cursor-pointer">
                itaobuy sheet
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-full py-3.5 text-center text-sm font-semibold rounded-full bg-accent-500 text-background-50 cursor-pointer">
                buy it now
                <i className="ri-external-link-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}